<div *ngIf="appState | async as appStateData" class="app-bg p-4">
  <div class="flex flex-col gap-y-1">
    <div class="flex justify-between items-end">
      <div class="flex flex-col">
        <div>Model:</div>
        <div
          [matTooltip]="appStateData.app.settings?.deviceDetails?.deviceResource?.model ?? ''"
          class="font-bold truncate max-w-[200px]"
        >
          {{ appStateData.app.settings?.deviceDetails?.deviceResource?.model }}
        </div>
      </div>
      <button
        mat-icon-button
        [cdkCopyToClipboard]="appStateData.app.settings?.deviceDetails?.deviceResource?.model ?? ''"
      >
        <mat-icon class="text-base">content_copy</mat-icon>
      </button>
    </div>

    <div class="flex justify-between items-end">
      <div class="flex flex-col">
        <div>Serial number:</div>
        <div
          [matTooltip]="appStateData.app.settings?.deviceDetails?.details?.serialNumber ?? ''"
          class="font-bold truncate max-w-[200px]"
        >
          {{ appStateData.app.settings?.deviceDetails?.details?.serialNumber }}
        </div>
      </div>
      <button
        mat-icon-button
        [cdkCopyToClipboard]="appStateData.app.settings?.deviceDetails?.details?.serialNumber ?? ''"
      >
        <mat-icon class="text-base">content_copy</mat-icon>
      </button>
    </div>

    <div class="flex justify-between items-end">
      <div class="flex flex-col">
        <div>Chrome version:</div>
        <div
          [matTooltip]="appStateData.app.settings?.deviceDetails?.details?.OSVersion ?? ''"
          class="font-bold truncate max-w-[200px]"
        >
          {{ appStateData.app.settings?.deviceDetails?.details?.OSVersion }}
        </div>
      </div>
      <button mat-icon-button [cdkCopyToClipboard]="appStateData.app.settings?.deviceDetails?.details?.OSVersion ?? ''">
        <mat-icon class="text-base">content_copy</mat-icon>
      </button>
    </div>

    <div class="flex justify-between items-end">
      <div class="flex flex-col">
        <div>Id:</div>
        <div
          [matTooltip]="appStateData.app.settings?.deviceDetails?.details?.id ?? ''"
          class="font-bold truncate max-w-[200px]"
        >
          {{ appStateData.app.settings?.deviceDetails?.details?.id }}
        </div>
      </div>
      <button mat-icon-button [cdkCopyToClipboard]="appStateData.app.settings?.deviceDetails?.details?.id ?? ''">
        <mat-icon class="text-base">content_copy</mat-icon>
      </button>
    </div>
  </div>
</div>
